import { render, staticRenderFns } from "./MultiChoice.vue?vue&type=template&id=5a99bd1e&"
import script from "./MultiChoice.vue?vue&type=script&lang=js&"
export * from "./MultiChoice.vue?vue&type=script&lang=js&"
import style0 from "./MultiChoice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports